module.exports = __webpack_public_path__ + "media/images/tenant_form-b1f4414398f632885d9615f03ffc588c.svg";